export function useAboutModal() {
  const isOpen = useState('about-modal-open', () => false)
  const { trackEvent } = useAnalytics()

  return {
    close: () => { isOpen.value = false },
    isOpen,
    // Track every opening of the modal so we know how many sessions
    // engage with the about copy. Source is provided by the caller
    // (header nav, setup menu, footer link, etc.) so we can attribute
    // the open to the surface that triggered it.
    open: (source?: string) => {
      isOpen.value = true
      trackEvent('about_modal_opened', source ? { source } : undefined)
    },
  }
}
